export default __webpack_public_path__ + "static/media/illucid.377cd69d.png";